export default __webpack_public_path__ + "static/finishedwax-91e5da6e23d3266717a7403ece2ea824.png";